<template>
  <b-modal
    title="Genial!"
    ref="confirmModal"
    hide-footer
    hide-header-close
    centered
    no-close-on-backdrop
  >
    <h6 v-if="state === DRAFT">Se ha guardado el borrador {{dntCode}}</h6>
    <h6 v-else-if="isMotherDocument">
      Excelente, has realizado el registro del documento y el n&uacute;mero
      de ingreso es: <b>{{dntCode}}</b>. Se ha creado el expediente con este
      mismo n&uacute;mero de ingreso.
    </h6>
    <h6 v-else-if="!isMotherDocument">
      Excelente, has realizado el registro del documento y el n&uacute;mero
      de ingreso es: <b>{{dntCode}}</b>. Se ha asociado correctamente al
      expediente <b>{{motherDocNumber}}</b>.
    </h6>
    <div class="d-flex justify-content-end">
      <b-button @click="closeModal" variant="success">
        Ok
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'Confirm',
  props: [
    'showConfirm',
    'dntCode',
    'resetData',
    'isMotherDocument',
    'motherDocNumber',
    'state',
    'fromEditAction'
  ],
  data() {
    return {
      ENTERED: 2,
      DRAFT: 3
    };
  },
  watch: {
    showConfirm(val) {
      if (val) this.$refs.confirmModal.show();
    }
  },
  computed: {
    fromDocDigital() {
      return this.$route.params.from === 'docDigital';
    }
  },
  methods: {
    closeModal() {
      if (!this.fromEditAction) {
        this.resetData();
      }
      this.$refs.confirmModal.hide();
      if (this.fromDocDigital && this.state === this.ENTERED) {
        this.$router.push({ name: 'dd-files', params: { view: 'recibidos' } });
      }
      this.$emit('closeModal', false);
    }
  }
};
</script>
